/**
 * Validation helpers for member detail modifications
 */

/**
 * Detect which fields have changed
 * @param {Object} originalMember - Original member data
 * @param {Object} updatedMember - Updated member data
 * @returns {Array} - Array of changed fields with before/after values
 */
export const detectChangedFields = (originalMember, updatedMember) => {
  const changes = [];
  const fieldsToCheck = [
    { key: 'first_name', label: 'First Name' },
    { key: 'middle_name', label: 'Middle Name' },
    { key: 'last_name', label: 'Last Name' },
    { key: 'gender', label: 'Gender' },
    { key: 'national_id', label: 'National ID' },
    { key: 'passport', label: 'Passport' },
    { key: 'msisdn', label: 'Phone Number' },
    { key: 'postal_address', label: 'Postal Address' },
    { key: 'residential_address', label: 'Residential Address' }
  ];

  fieldsToCheck.forEach(field => {
    const originalValue = originalMember[field.key] || '';
    const updatedValue = updatedMember[field.key] || '';

    // Normalize for comparison
    const normalizedOriginal = String(originalValue).trim();
    const normalizedUpdated = String(updatedValue).trim();

    if (normalizedOriginal !== normalizedUpdated) {
      changes.push({
        field: field.label,
        key: field.key,
        before: normalizedOriginal || 'N/A',
        after: normalizedUpdated || 'N/A'
      });
    }
  });

  return changes;
};
